import { _ftCamField } from './campaign-field';
import { campaignLightForClock } from './campaign-light';
import { ftClockBaseFromArr, ftClockColsFromArr, ftDeriveCampaignClock, ftCampaignTimeAddSeconds, ftCampaignTimeSubtractSeconds } from './campaign-clock';

export type ClockAction = 'play' | 'pause' | 'checkpoint' | 'sync' | 'adjust' | 'offline';
export function planCampaignClock(campaign: Record<string, unknown>, action: ClockAction, now: number, seconds = 0) {
    const base = ftClockBaseFromArr(campaign);
    if (!base.calendar.months.length || base.calendar.months.some(m => m.days_in_month < 1)
        || !base.calendar.months.some(m => m.month_order === base.cols.month)) throw Error('calendar-light:calendar-unavailable');
    if (base.runningSinceRaw && !base.derived) throw Error('calendar-light:calendar-unavailable');
    const derived = ftDeriveCampaignClock(base, now);
    const clock = seconds < 0 ? ftCampaignTimeSubtractSeconds(derived.cols, base.calendar, -seconds)
        : ftCampaignTimeAddSeconds(derived.cols, base.calendar, seconds);
    const light = campaignLightForClock(campaign, clock);
    const beforeLight = _ftCamField(campaign, 'campaign_light') ?? '';
    const beforeSun = _ftCamField(campaign, 'campaign_sun_state') ?? '';
    const running = action === 'pause' ? false : action === 'play' || derived.running;
    return { before: { clock: ftClockColsFromArr(campaign), running_since: base.runningSinceRaw,
        campaign_light: beforeLight, campaign_sun_state: beforeSun,
        calendar_id: _ftCamField(campaign, 'calendar_id') ?? '', campaign_light_cycle_mode: _ftCamField(campaign, 'campaign_light_cycle_mode') ?? '' },
        after: { clock, running_since: running ? new Date(Math.floor(now / 1000) * 1000).toISOString().slice(0, 19).replace('T', ' ') : null,
            campaign_light: light.campaign_light, campaign_sun_state: light.campaign_sun_state, sun_transition_minutes: light.transitions },
        elapsed_seconds: derived.elapsedSeconds, elapsed_clock: derived.cols,
        rows: beforeLight === light.campaign_light && beforeSun === light.campaign_sun_state || !light.message ? []
            : [{ roll_type_1: light.message, roll_result: 0, roll_private: 0, rolls_full: '' }],
    };
}
export type CampaignClockPlan = ReturnType<typeof planCampaignClock>;
